import { render, staticRenderFns } from "./XUsers.vue?vue&type=template&id=fac4608e"
import script from "./XUsers.vue?vue&type=script&lang=js"
export * from "./XUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports